import {Component} from '@angular/core';
import {BaseOrganizationComponent} from '../base-organization.component';
import {LoadingService, OrganizationEvent, OrganizationEventService, OrganizationService, UserService, VenueService} from 'brewbill-lib';
import {AlertController, ModalController, NavController} from '@ionic/angular';
import {EditPickupLocationComponent} from '../edit-pickup-location/edit-pickup-location.component';
import {EditCustomerAreaComponent} from '../edit-customer-area/edit-customer-area.component';
import {EditOrganizationEventComponent} from '../edit-organization-event/edit-organization-event.component';

@Component({
    selector: 'bb-organization-locations',
    templateUrl: './organization-locations.component.html',
    styleUrls: ['./organization-locations.component.scss'],
})
export class OrganizationLocationsComponent extends BaseOrganizationComponent {

    constructor(
        organizationService: OrganizationService,
        pickupLocationService: VenueService,
        userService: UserService,
        venueService: VenueService,
        loadingService: LoadingService,
        private organizationEventService: OrganizationEventService,
        private alertController: AlertController,
        private modalController: ModalController,
        private navController: NavController
    ) {
        super(organizationService,
            pickupLocationService,
            userService,
            venueService,
            loadingService);
    }

    async openEditPickupLocation() {
        const modal = await this.modalController.create({
            component: EditPickupLocationComponent,
            cssClass: 'menu-modal',
            componentProps: {
                organization: this.organization,
                venue: this.venue,
                pickupLocation: null
            }
        });

        await modal.present();

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned !== null && dataReturned.data != null) {
                this.refreshOrganization();
            }
        });
    }

    async addCustomerArea() {
        const modal = await this.modalController.create({
            component: EditCustomerAreaComponent,
            componentProps: {
                organization: this.organization
            }
        });

        await modal.present();

        await modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned !== null && dataReturned.data != null) {
                this.navController.navigateForward(`/customer-area/${dataReturned.data.id}/${this.organization.id}`);
            }
        });
    }

    async editOrganizationEvent(organizationEvent: OrganizationEvent) {
        this.loadingService.present();
        const modal = await this.modalController.create({
            component: EditOrganizationEventComponent,
            cssClass: 'menu-item-modal',
            componentProps: {
                organizationEvent,
                organization: this.organization
            }
        });

        this.loadingService.dismiss();
        await modal.present();

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned !== null && dataReturned.data != null) {
                this.refreshOrganization();
            }
        });
    }

    async confirmDeleteEvent(event, organizationEvent: OrganizationEvent) {
        event.preventDefault();
        event.stopPropagation();
        const alert = await this.alertController.create({
            cssClass: 'brewbill-alert',
            header: 'Confirm Delete',
            message: 'Are you sure you want to remove ' + organizationEvent.name + '?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel'
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.loadingService.present();
                        this.organizationEventService.delete(organizationEvent.id).subscribe(() => {
                            this.loadingService.dismiss();
                            this.organization.events = this.organization.events.filter(e => e.id !== organizationEvent.id);
                        });
                    }
                }
            ]
        });

        await alert.present();
    }
}
